import React from 'react'
import PropTypes from 'prop-types'
import arraySort from 'array-sort'
import Select from 'react-select'

export const AcademicYearSelect = ({
  academicYears = [],
  handleSelectedAcademicYearChange,
  selectedAcademicYear
}) => {
  const mapList = AY =>
    arraySort(
      AY.map(ay => ({
        label: ay.name,
        name: ay.name,
        id: ay.id,
        sort_order: ay.sort_order
      }))
    ).filter(el => el !== false)

  const mappedAcademicYears = mapList(academicYears)

  return (
    <Select
      options={mappedAcademicYears}
      value={mappedAcademicYears.find(st => st.id === selectedAcademicYear.id)}
      onChange={handleSelectedAcademicYearChange}
      clearable={false}
      className="course-builder-select"
      searchable={false}
    />
  )
}

AcademicYearSelect.propTypes = {
  academicYears: PropTypes.array.isRequired,
  handleSelectedAcademicYearChange: PropTypes.func.isRequired,
  selectedAcademicYear: PropTypes.object
}

export default AcademicYearSelect



// WEBPACK FOOTER //
// ./src/components/mycourses/AcademicYearSelect.js